import { useState } from 'react';
import { FileText, CreditCard, Building2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export function InvoicesTab({ invoices, fmt, fmtDate, onPay }) {
  if (invoices.length === 0) return <div className="bg-white rounded-xl border border-gray-200 p-12 text-center"><FileText className="w-12 h-12 text-gray-300 mx-auto mb-4" /><p className="text-gray-500">No invoices yet</p></div>;
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <table className="w-full"><thead className="bg-gray-50"><tr>
        <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Invoice #</th>
        <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Date</th>
        <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Amount</th>
        <th className="text-center px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Status</th>
        <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Action</th>
      </tr></thead><tbody className="divide-y">
        {invoices.map(inv => <InvoiceRow key={inv.id} inv={inv} fmt={fmt} fmtDate={fmtDate} onPay={onPay} />)}
      </tbody></table>
    </div>
  );
}

function InvoiceRow({ inv, fmt, fmtDate, onPay }) {
  const [method, setMethod] = useState('cc');

  return (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4 font-medium text-[#0A1628]">{inv.invoice_number}</td>
      <td className="px-6 py-4 text-gray-600">{fmtDate(inv.created_at)}</td>
      <td className="px-6 py-4 text-right">
        <span className="font-semibold">{fmt(inv.total)}</span>
        {inv.status !== 'paid' && (
          <p className="text-[10px] text-amber-600 font-normal mt-0.5">+ processing fee at checkout</p>
        )}
        {inv.processing_fee > 0 && inv.status === 'paid' && (
          <p className="text-[10px] text-gray-500 font-normal mt-0.5">+ {fmt(inv.processing_fee)} fee charged</p>
        )}
      </td>
      <td className="px-6 py-4 text-center"><span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${inv.status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>{(inv.status || 'pending').toUpperCase()}</span></td>
      <td className="px-6 py-4 text-right">
        {inv.status !== 'paid' && (
          <div className="flex flex-col items-end gap-1">
            <div className="flex items-center gap-2">
              <div className="flex rounded-lg border overflow-hidden text-xs">
                <button onClick={() => setMethod('cc')} className={`px-2 py-1.5 flex items-center gap-1 ${method === 'cc' ? 'bg-[#014DB7] text-white' : 'bg-white text-gray-500'}`}><CreditCard className="w-3 h-3" /> Card</button>
                <button onClick={() => setMethod('ach')} className={`px-2 py-1.5 flex items-center gap-1 ${method === 'ach' ? 'bg-[#84CC16] text-white' : 'bg-white text-gray-500'}`}><Building2 className="w-3 h-3" /> ACH</button>
              </div>
              <Button size="sm" onClick={() => onPay(inv.id, method)} className="bg-[#84CC16] hover:bg-[#65a30d] text-white rounded-lg">Pay Now</Button>
            </div>
            <span className="text-[10px] text-amber-600">Processing fee (2.9% + $0.30) applied at checkout</span>
          </div>
        )}
      </td>
    </tr>
  );
}
